import React from 'react'
import { Line, Bar } from 'react-chartjs-2'
import { Grid } from '@material-ui/core'

import Card from 'src/components/sharedComponents/Card/Card'
import CardBody from 'src/components/sharedComponents/Card/CardBody'
import CardHeader from 'src/components/sharedComponents/Card/CardHeader'
import * as Utils from 'src/utils/chartsUtils'
import TableAA from 'src/components/reports/Tables/TableAA'
import TableIndustry from 'src/components/reports/Tables/TableIndustry'
import TableAAPP from 'src/components/reports/Tables/TableAAPP'
import { useStyles } from '../styles'

const Total3WMarketCard = (props) => {
  const {
    disableG2 = false,
    g2Param = '',
    table2Param = '',
    titleCard = '',
    arrayTable1 = [],
    selectedDate,
    arrayTable2 = [],
    arrayTable3 = [],
    arrayG1 = [],
    arrayG2A = [],
    arrayG2B = [],
    arrayG3A = [],
    arrayG3B = [],
  } = props
  const classes = useStyles()
  return (
    <Card>
      <CardHeader>
        <div className={classes.center}>
          <div>
            <h3>{titleCard}</h3>
          </div>
          {`  `}
        </div>
      </CardHeader>
      <CardBody>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={12} lg={6}>
            <TableAA
              array={arrayTable1}
              selectedDate={selectedDate}
              disableAA
            />
          </Grid>
          <Grid item xs={12} sm={12} lg={6}>
            <h3>Evolución Total - {selectedDate.getFullYear()}</h3>
            <br />
            <Bar
              data={Utils.simpleBarLine(
                arrayG1,
                'YYYY',
                'CANT',
                'VAR',
                'Año',
                1,
              )}
              options={Utils.optionsSimpleBarChart}
            />{' '}
          </Grid>
          {!disableG2 ? (
            <>
              <Grid item xs={12} sm={12} lg={12}>
                <TableAAPP
                  array={arrayTable2}
                  selectedDate={selectedDate}
                  param={table2Param}
                  AA
                />
              </Grid>
              <Grid item xs={12} sm={12} lg={6}>
                <h3>Participación del mercado sub-categorías - años</h3>
                <br />
                <Bar
                  data={Utils.customBarLineDataGroup(
                    arrayG2A,
                    g2Param,
                    'PORCENTAJE',
                    'YYYY',
                    '100',
                  )}
                  options={Utils.optionsSimpleBarChart}
                />
              </Grid>
              <Grid item xs={12} sm={12} lg={6}>
                <h3>Participación del mercado sub-categorías - mes</h3>
                <br />
                <Bar
                  data={Utils.customBarLineDataGroup(
                    arrayG2B,
                    g2Param,
                    'PORCENTAJE',
                    'MES',
                    '100',
                  )}
                  options={Utils.optionsSimpleBarChart}
                />
              </Grid>
            </>
          ) : null}
          <br />
          <div className={classes.center}>
            <h3>Evolución Total del Mercado por compañía</h3>
          </div>
          <Grid item xs={12} sm={12} lg={12}>
            <TableIndustry
              array={arrayTable3}
              selectedDate={selectedDate}
              param="EMPRESA"
            />
          </Grid>
          <Grid item xs={12} sm={12} lg={6}>
            <h3>Participación del mercado - años</h3>
            <br />
            <Line
              data={Utils.customBarLineDataGroup(
                arrayG3A,
                'EMPRESA',
                'PORCENTAJE',
                'YYYY',
                '100',
              )}
              options={Utils.optionsLine}
            />
          </Grid>
          <Grid item xs={12} sm={12} lg={6}>
            <h3>Participación del mercado - mes</h3>
            <br />
            <Line
              data={Utils.customBarLineDataGroup(
                arrayG3B,
                'EMPRESA',
                'PORCENTAJE',
                'MES',
                '100',
              )}
              options={Utils.optionsLine}
            />
          </Grid>
        </Grid>
      </CardBody>
    </Card>
  )
}

export default Total3WMarketCard
